import { z } from 'zod';
import { withSortableParams } from '../../helpers';
import { ActionRef } from 'further-types/lp/action';
import { CalendarDay } from '../../../utils';
import {
  TrialBalanceDateOption,
  TrialBalanceGroupByOption,
} from 'further-types/lp/general-ledger';

export const ListTransactionsInput = withSortableParams(
  z.object({
    endDate: z.instanceof(CalendarDay).optional(),
    searchQuery: z.string().optional(),
    actionRefs: z.array(z.nativeEnum(ActionRef)).optional(),
  }),
  [
    'accountLabel',
    'accountSection',
    'transactionType',
    'transactionDate',
    'vatRate',
    'amountIncVatLcy',
    'amountIncVatTcy',
    'transactionCurrency',
    'description',
    'ledgerComment',
    'counterpartyLabel',
    'counterpartyRef',
    'createdByLabel',
    'bankAccountLabel',
  ],
);

export const ExportTransactionListInput = z.object({
  endDate: z.instanceof(CalendarDay).optional(),
  searchQuery: z.string().optional(),
  actionRefs: z.array(z.nativeEnum(ActionRef)).optional(),
});

export const TrialBalanceInput = z.object({
  vehicleId: z.string(),
  dateOption: z.nativeEnum(TrialBalanceDateOption),
  customDate: z.instanceof(CalendarDay).optional(),
  groupBy: z.nativeEnum(TrialBalanceGroupByOption),
});
